var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M96.002 6.25c-32.666 24.723-63.994 57.793-63.994 57.793l-22.576-20.293-9.431 9.607c9.279 8.721 30.778 31.758 38.050 40.393 20.468-34.197 41.746-59.701 61.95-83.023l-3.998-4.477z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }